import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../assets/styles/Timeline.scss";

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "white", color: "rgb(39, 40, 34)" }}
            contentArrowStyle={{ borderRight: "7px solid  white" }}
            date="2025 - present"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Supervisor - Digital Transformation & Innovation</h3>
            <h4 className="vertical-timeline-element-subtitle">
            Kuwait Credit Information Network Company (CINET)
            </h4>
            {/* <ul>
              <li>
                Contribute to monitoring, diagnosing, and resolving issues
                across systems, applications, and databases
              </li>
              <li>
                Design, develop, and maintain Authority’s websites and various
                portals.
              </li>
              <li>
                Participating in designing and implementing databases and
                automated systems for efficient data storage and access for
                stakeholders.
              </li>
              <li>
                {" "}
                Collaborate with stakeholders to define requirements, ensure
                progress through follow-ups, and deliver high-quality solutions
                on time.
              </li>
            </ul> */}
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "white", color: "rgb(39, 40, 34)" }}
            contentArrowStyle={{ borderRight: "7px solid  white" }}
            date="2023 - 2025"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Programmer</h3>
            <h4 className="vertical-timeline-element-subtitle">
              Capital Markets Authority, Kuwait
            </h4>
            <ul>
              <li>
                Contribute to monitoring, diagnosing, and resolving issues
                across systems, applications, and databases
              </li>
              <li>
                Design, develop, and maintain Authority’s websites and various
                portals.
              </li>
              <li>
                Participating in designing and implementing databases and
                automated systems for efficient data storage and access for
                stakeholders.
              </li>
              <li>
                {" "}
                Collaborate with stakeholders to define requirements, ensure
                progress through follow-ups, and deliver high-quality solutions
                on time.
              </li>
            </ul>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2018 - 2022"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Software Engineer
            </h3>
            <h4 className="vertical-timeline-element-subtitle">BAWES, Kuwait</h4>
            <ul>
              <li>Executed the full software development life cycle (SDLC).</li>
              <li>Developed well-structured, testable, and efficient code.</li>
              <li>Troubleshot, debugged, and enhanced existing systems.</li>
              <li>
                Ensured compliance with project plans and industry standards.
              </li>
              <li>
                Gathered and communicated stakeholder requirements to
                development teams.
              </li>
              <li>
                Automated and streamlined development and release processes.
              </li>
              <li>
                Implemented cybersecurity measures to safeguard systems against
                threats.
              </li>
            </ul>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2017 - 2017"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
            Full Stack Engineer Intern
            </h3>
            <h4 className="vertical-timeline-element-subtitle">BAWES, Kuwait</h4>
            <ul>
              <li>Designed and implemented efficient, scalable APIs</li>
              <li>Integrated APIs with frontend to retrieve and push data seamlessly</li>
              <li>Identified and resolved backend and frontend issues for smoother functionality</li>
              <li>Optimized application performance across all layers for a seamless experience</li>
              <li>Applied data security best practices to protect user information</li>
            </ul>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2017 - 2017"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Front-End Developer Intern
            </h3>
            <h4 className="vertical-timeline-element-subtitle">BAWES, Kuwait</h4>
            <ul>
              <li>Developed responsive websites and mobile applications</li>
              <li>Ensured cross-platform compatibility for seamless user experience on various devices</li>
              <li>Collaborated with team members to enhance UI/UX design for better user engagement</li>
              <li>Conducted testing and debugging to maintain app stability and performance</li>
            </ul>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
